import { render, staticRenderFns } from "./InfosGroup.vue?vue&type=template&id=3e1bc536&scoped=true&"
import script from "./InfosGroup.vue?vue&type=script&lang=ts&"
export * from "./InfosGroup.vue?vue&type=script&lang=ts&"
import style0 from "./InfosGroup.vue?vue&type=style&index=0&id=3e1bc536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1bc536",
  null
  
)

export default component.exports